
import "./pt-piping-three-way-L-port.css"

export default {
  model: {
    "position": {
      type: "list",
      format: ["POSITION 1", "POSITION 2"],
      default: "POSITION 1"
    },
  
  },
  listeners: {
    mouseenter: true,
    mouseleave: true,
    click: true,
    contextmenu: true
  }
}
